// AudioRecorder.js
import React, { useState, useEffect, useRef } from 'react';

const AudioRecorder = ({ isRecording, setAudioUrl, setIsRecording, handleAudioRecorded  }) => {
  const [audioStream, setAudioStream] = useState(null);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const audioRef = useRef(null);

  useEffect(() => {
    return () => {
      if (audioStream) {
        audioStream.getTracks().forEach(track => track.stop());
      }
    };
  }, [audioStream]);

  const startRecording = () => {
    navigator.mediaDevices.getUserMedia({ audio: true })
      .then(stream => {
        setAudioStream(stream);
        const recorder = new MediaRecorder(stream);
        let audioChunks = [];
        setMediaRecorder(recorder);

        recorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            audioChunks.push(event.data);
          }
        };

        recorder.onstop = () => {
          const blob = new Blob(audioChunks, { type: 'audio/mpeg' });
          const url = URL.createObjectURL(blob);
          setAudioUrl(url); // Pass the URL of the recorded audio
          handleAudioRecorded(url);
        setIsRecording(false); // Update recording status
          stream.getTracks().forEach(track => track.stop()); // Stop all streams
        };

        recorder.start();
      })
      .catch(error => {
        console.error('Error accessing the microphone:', error);
        setIsRecording(false); // If error occurs, stop the recording
      });
  };

  const stopRecording = () => {
    if (mediaRecorder) {
      mediaRecorder.stop(); // Stop the recorder when button is clicked
    }
  };

  useEffect(() => {
    if (isRecording) {
      startRecording(); // Start recording when the isRecording state is true
    } else {
      stopRecording(); // Stop recording when isRecording is false
    }
  }, [isRecording]); // Dependency on isRecording to toggle recording state

  
  return <></>; // No UI here, recording happens in the background
};

export default AudioRecorder;
